import { z } from 'zod'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { SignIn } from '@/features/auth/sign-in'
import { hasBackOfficeAccess } from '@/lib/auth'
import { getCachedAuth } from '@/lib/auth-cache'

const searchSchema = z.object({
  redirect: z.string().optional(),
})

export const Route = createFileRoute('/(auth)/sign-in')({
  beforeLoad: () => {
    // Only use cached auth (set by AuthProvider) - no network calls, no DB queries
    // If cache exists and user has access, redirect to dashboard
    // Otherwise, show sign-in page immediately
    const { cachedUserRole } = getCachedAuth()
    if (cachedUserRole && hasBackOfficeAccess(cachedUserRole)) {
      throw redirect({ to: '/' })
    }
  },
  component: SignIn,
  validateSearch: searchSchema,
})
